<template>
  <div class="container">
    <TrfHeader pageTitle="Minhas tarefas"/>
    
    <TrfSimpleModal :titulo="this.tituloModalDetalhesHistorico" :isAtivo="isModalDetalhesHistoricoAtivo" @close="fecharModalDetalhesHistorico" :isModalPersonalizado="true">
      <TrfDetalhesHistorico v-if="isModalDetalhesHistoricoAtivo" :tarefa="detalhesHistorico"></TrfDetalhesHistorico>
    </TrfSimpleModal>

    <TrfSimpleModal v-e2e="'pausar-historico-modal'" id="pausar-historico-modal" :titulo="tituloModalPausar" :isAtivo="isModalPausarAtivo" @close="fecharModalPausar" :isModalPersonalizado="false">
      <div class="px-2 py-1">
        <TrfParalisarFormComponent ref="paralisarForm" :tarefa="itemEmAcesso" @done:action="async () => {await tarefaParalisadaCallback()}" @error:save="() => setBtnModalLoading(false)"></TrfParalisarFormComponent>
      </div>
      <template #slot-footer>
        <TrfButton nome="Confirmar" type="button" classCor="is-primary" :is-btn-loading="isBtnModalLoading" @click="doParalisarTarefa" v-e2e="'modal-paralisar-btn-confirmar'"></TrfButton>
        <TrfButton nome="Cancelar" type="button" @click="fecharModalPausar" v-e2e="'modal-paralisar-btn-cancelar'"></TrfButton>
      </template>
    </TrfSimpleModal>

    <TrfSimpleModal v-e2e="'continuar-historico-modal'" id="continuar-historico-modal" :titulo="tituloModalContinuar" :isAtivo="isModalContinuarAtivo" @close="fecharModalContinuar" :isModalPersonalizado="false">
      <div class="px-2 py-1">
        <p>Deseja continuar esta {{ `${itemEmAcesso?.isFase? 'fase' : 'tarefa'}` }}?</p>
        <br/>
        <p>
          <strong>Atenção:</strong> Ao clicar em confirmar, a {{ `${itemEmAcesso?.isFase? 'fase' : 'tarefa'}` }} será retirada do status "Paralisada" e retornará para o status original.
        </p>
      </div>
      <template #slot-footer>
        <TrfButton nome="Confirmar" type="button" classCor="is-primary" :is-btn-loading="isBtnModalLoading" @click="doContinuarTarefa" v-e2e="'modal-continuar-btn-confirmar'"></TrfButton>
        <TrfButton nome="Cancelar" type="button" @click="fecharModalContinuar" v-e2e="'modal-continuar-btn-confirmar'"></TrfButton>
      </template>
    </TrfSimpleModal>

    <TrfSimpleModal :titulo="tituloModalEdicaoAvulsa" :isAtivo="isModalEdicaoDeFasesActive" @close="cancelamentoModalEdicaoAvulsa">
      <div>
        <TrfFormularioEdicaoAvulsa
          ref="formularioEdicao"
          v-show="!modalEdicaoAtivo"
          :tarefa-em-edicao="avulsaEmEdicao"
          :lista-de-responsaveis="responsavelOptionsSemAgenteIA"
          :lista-de-departamentos="listaDepartamentos"
          :listaDepartamentosFase="listaTodosDepartamentos"
          :lista-de-modelos-exibicao="listaDeModelosExibicao"
          :lista-de-modelos="listaDeModelos"
          :loading-departamentos="modalLoading.campoDepartamento"
          :loading-responsaveis="modalLoading.campoResponsavel"
          @ativarConfirmacaoEdicao="($event) => modalEdicaoAtivo = $event"
          @update:values="($event) => atualizarValoresEdicao($event)"
          @isModeloImportado="($event) => modeloImportado = $event"
        ></TrfFormularioEdicaoAvulsa>
        <div class="content" v-show="origemTarefaEnum.ATENDIMENTO.equals(modalEdicaoAtivo)">
          <p>
            Identificamos que essa tarefa é proveniente de um atendimento.
            <br/><br/>
            Importar um novo modelo irá sobrescrever os dados da tarefa. Somente os campos Nome da tarefa e Descrição não serão substituídos.
            <br/><br/>
            <strong>Confirma a importação?</strong>
          </p>
        </div>
        <div class="content" v-show="origemTarefaEnum.DEPARTAMENTO_PESSOAL.equals(modalEdicaoAtivo)">
          <p>
            Identificamos que essa tarefa é proveniente do Departamento pessoal.
            <br/><br/>
            Importar um novo modelo irá sobrescrever os dados da tarefa. Somente o campo Nome da tarefa não será substituído.
            <br/><br/>
            <strong>Confirma a importação?</strong>
          </p>
        </div>
        <div class="content" v-show="origemTarefaEnum.EEXTRATOS.equals(modalEdicaoAtivo)">
          <p>
            Identificamos que essa tarefa é proveniente do eExtratos.
            <br/><br/>
            Importar um novo modelo irá sobrescrever os dados da tarefa. Somente o campo Nome da tarefa não será substituído.
            <br/><br/>
            <strong>Confirma a importação?</strong>
          </p>
        </div>
        <div class="content" v-show="origemTarefaEnum.CERTIFICADOS_DIGITAIS.equals(modalEdicaoAtivo)">
          <p>
            Identificamos que essa tarefa é proveniente da Central de certificados digitais.
            <br/><br/>
            Importar um novo modelo irá sobrescrever os dados da tarefa. Somente o campo Nome da tarefa não será substituído.
            <br/><br/>
            <strong>Confirma a importação?</strong>
          </p>
        </div>
        <div class="content" v-show="origemTarefaEnum.ELEGALIZE.equals(modalEdicaoAtivo)">
          <p>
            Identificamos que essa tarefa é proveniente do eLegalize.
            <br/><br/>
            Importar um novo modelo irá sobrescrever os dados da tarefa. Somente o campo Nome da tarefa não será substituído.
            <br/><br/>
            <strong>Confirma a importação?</strong>
          </p>
        </div>
        <div class="content" v-show="origemTarefaEnum.NENHUMA.equals(modalEdicaoAtivo)">
          <p>
            Identificamos que essa tarefa é do tipo avulsa.
            <br/><br/>
            Importar um novo modelo irá sobrescrever os dados da tarefa. 
            <br/><br/>
            <strong>Confirma a importação?</strong>
          </p>
        </div>
        <div class="content" v-show="modalEdicaoAtivo == 'resetarModelo'">
          <p>
            Ao desmarcar esta opção, o modelo importado será removido.
            <br/><br/>
            <strong>Deseja continuar?</strong>
          </p>
        </div>
        <div class="content" v-show="modalEdicaoAtivo == 'permissao'">
          <p>
            Identificamos que o(s) usuário(s) vinculado(s) na(s) fase(s) listada(s) abaixo, não possui as permissões necessárias para acessar o
            departamento vinculado ao modelo. Com isso, as fases relacionadas a esses departamento não estarão visíveis na área de dashboard do
            usuário.
          </p>
          <p>
            Para resolver esta situação será preciso ajustar o cadastro do(s) usuário(s) responsável(eis) concedendo a permissão a este departamento.
          </p>
          <p>
            <strong>Gostaria de conceder esta permissão a este(s) usuário(s)?</strong><br />
            OBS.: Caso não deseje conceder a permissão, será necessário atribuir um novo responsável para a fase que possua permissão para o
            departamento vinculado ao modelo.
          </p>

          <TrfTabela
            v-if="errosDePermissao.length > 0"
            :dataConfig="dataSourceErroPermissao"
            :data="errosDePermissao"
            :isButtonMoreHidden="true"
            :showDropdownOptions="false"
            :showButtonsDefault="true"
            dataStatus=""
            :isScrollAnexos="false"
            :showEdit="false"
            :showDelete="false"
            :shouldIgnorePreDelete="true"
          >
          </TrfTabela>
        </div>
      </div>
      <template #slot-footer>
        <div class="buttons is-right">
          <TrfButton
            :nome="!modalEdicaoAtivo? 'Editar' : 'Sim'"
            :temIcon="false"
            id="btn-editar-avulsa"
            type="button"
            classCor="is-primary"
            :disabled="modalLoading.realizandoEdicao || modalLoading.campoDepartamento || modalLoading.campoResponsavel"
            :isBtnLoading="modalLoading.realizandoEdicao"
            @click.prevent="async ($event) => await confirmacaoModalEdicaoAvulsa($event)"
          />
          <TrfButton
            :nome="!modalEdicaoAtivo? 'Cancelar' : 'Não'"
            :temIcon="false"
            id="btn-cancelar-avulsa"
            type="button"
            :disabled="modalLoading.realizandoEdicao"
            @click.prevent="cancelamentoModalEdicaoAvulsa"
          />
        </div>
      </template>
    </TrfSimpleModal>

    <TrfModal
      v-if="isModalConcluirActive"
      idModal="trf-modal-concluir-selecionado"
      titulo="Concluir tarefas"
      btnSaveName="Confirmar"
      :isBtnLoading="isModalConcluirLoading"
      @save="async (event) => await concluirTarefasEmBloco(event)"
      @close="fecharModalConclusao"
    >
      <p>Deseja realmente concluir esta(s) <strong>tarefa(s)</strong>?<br /><br /></p>

      <!-- Remover o is-hidden quando adicionar a auditoria na conclusão da tarefa -->
      <div class="is-hidden">
        <p><strong>Motivo para registro na auditoria:</strong></p>
        <textarea name="trf-modal-concluir-selecionado-motivo" id="trf-modal-concluir-selecionado-motivo" ref="trfConclusaoMotivo" cols="80" rows="5"></textarea>
      </div>
    </TrfModal>

    <TrfModal
      v-if="isModalExcluirEmBlocoActive"
      idModal="trf-modal-excluir-selecionado"
      titulo="Excluir tarefas"
      btnSaveName="Confirmar"
      :isBtnLoading="isModalExcluirEmBlocoLoading"
      @save="async (event) => await excluirTarefasEmBloco(event)"
      @close="fecharModalExclusaoEmBloco"
    >
      <p>Deseja realmente excluir esta(s) <strong>tarefa(s)</strong>?<br /><br /></p>

      <!-- Remover o is-hidden quando adicionar a auditoria na conclusão da tarefa -->
      <div class="is-hidden">
        <p><strong>Motivo para registro na auditoria:</strong></p>
        <textarea name="trf-modal-excluir-selecionado-motivo" id="trf-modal-excluir-selecionado-motivo" ref="trfExclusaoMotivo" cols="80" rows="5"></textarea>
      </div>
    </TrfModal>

    <div v-if="!this.permissoesTarefas || this.permissoesTarefas.Visualizar || this.isSuperAdm" class="columns is-align-items-flex-end">
      <div class="column is-narrow-desktop is-12-mobile">
        <label class="is-invisible">Nova tarefa avulsa</label>
        <TrfButton
          @click="openModal()"
          nome="Nova tarefa avulsa"
          classCor="is-primary"
          :temIcon="true"
          classIcon="mdi-plus"
          class="is-fullwidth"
          id="btn-nova-tarefa"
        />
      </div>

      <div class="column is-narrow-desktop is-12-mobile">
        <TrfButton
          @click="abrirModalConclusao()"
          nome="Concluir selecionada(s)"
          classCor="is-outlined"
          :temIcon="true"
          classIcon="mdi-chevron-down is-size-4"
          class="is-fullwidth"
          id="btn-concluir-selecionadas"
          title="Concluir tarefa(s) selecionada(s)"
          :disabled="!podeRealizarBaixa()"
        />
      </div>

      <div class="column is-narrow-desktop is-12-mobile">
        <TrfButton
          @click="abrirModalExclusaoEmBloco()"
          nome="Excluir selecionada(s)"
          classCor="is-outlined"
          :temIcon="true"
          classIcon="mdi-delete"
          class="is-fullwidth"
          id="btn-concluir-selecionadas"
          title="Excluir tarefa(s) selecionada(s)"
          :disabled="!podeRealizaExclusaoMultipla()"
        />
      </div>

      <div class="column is-narrow-desktop is-12-mobile">
        <TrfButton
          @click="abrirModalTransferirResponsavelSelecionadas()"
          nome="Transferir selecionada(s)"
          classCor="is-outlined"
          :temIcon="true"
          classIcon="mdi-share"
          class="is-fullwidth"
          id="btn-transferir-responsavel-selecionadas"
          title="Transferir tarefa(s) selecionada(s)"
          :disabled="!podeRealizarTransferenciaMultipla()"
        />
      </div>
      
      <div class="column is-flex-grow-1 is-hidden-mobile"></div>
      
      <div class="column is-narrow-desktop is-12-mobile">
        <TrfButton
          @click="exportarPlanilha()"
          nome="Exportar em *.XLSX"
          classCor="is-primary"
          :temIcon="true"
          :isBtnLoading="isBtnExportarPlanilhaLoading"
          classIcon="mdi-upload"
          class="is-fullwidth"
          id="btn-exportar-planilha"
          title="Exportar em *.XLSX"
        />
      </div>
    </div>

    <div class="columns is-align-items-flex-start is-justify-content-space-between">
      <div class="column is-12-mobile">
        <div class="columns is-align-items-flex-start is-3">
          <div class="column is-12-mobile">
            <label>Responsável</label>
            <Multiselect
              :searchable="true"
              :options="optionsFilterResponsavel"
              v-model="this.responsavelId"
              class="multiselect-econtador is-fullwidth"
              placeholder="Selecione"
              noResultsText="Responsável não encontrado"
              id="select-responsavel-filtrar"
            />
          </div>

          <div class="column is-12-mobile">
            <label>Empresa</label>
            <Multiselect
              :searchable="true"
              :options="this.listaEmpresas"
              v-model="this.empresaId"
              class="multiselect-econtador is-fullwidth"
              placeholder="Selecione"
              noResultsText="Empresa não encontrada"
              id="select-empresa-filtrar"
            />

            <div class="columns">
              <div class="column is-narrow">
                <label class="mt-4">Status</label>
                <TrfCheckboxFields
                  :listaDeOpcoes="this.statusOptions"
                  class="is-fullwidth"
                  id="select-status-filtrar"
                  @update:valoresSelecionados="(novoValor) => this.gerarFiltroStatus(novoValor)"
                />
              </div>
            </div>
          </div>

          <div class="column is-narrow-desktop is-12-mobile">
            <label>Intervalo</label>
            <TrfButtonSelector
              :listaDeOpcoes="this.intervalosOptions"
              class="is-fullwidth"
              id="select-intervalo-filtrar"
              :podeDesmarcar="true"
              @update:opcaoSelecionada="(novoValor) => (tratarFiltroIntervalo(novoValor))"
              ref="filtroBotoesIntervalo"
            />
          </div>
        </div>
      </div>

      <div class="column is-narrow-desktop is-12-mobile">
        <label class="is-invisible">Filtrar</label>
        <TrfButton
          id="btn-filtrar-historico"
          nome="Filtrar"
          class="is-fullwidth is-primary"
          @click="this._carregarListagem(true)"
        />

        <div class="column mt-4">
          <a @click="this.exibirFiltrosAvancados()">Filtro avançado</a>
        </div>
      </div>
    </div>

    <div class="box-filtro-avancado" :class="{'is-hidden': !activarFiltroAvancado}">
      <div class="columns is-align-items-flex-start">
        <TrfInput
          class="column is-3-desktop"
          label="Nome da tarefa"
          placeholder="Pesquise pelo nome da tarefa"
          margin="0"
          height="5.3rem"
          :temIcon="true"
          classIcon="mdi-magnify"
          id="barraPesquisa"
          v-model="this.nomeTarefa"
        />

        <div class="column is-3-desktop is-12-mobile">
          <label>Departamento</label>
          <Multiselect
            :searchable="true"
            :options="this.listaDepartamentos"
            v-model="this.departamentoId"
            class="multiselect-econtador is-fullwidth"
            placeholder="Selecione"
            noResultsText="Departamento não encontrado"
            id="select-departamento-filtrar"
          />
        </div>

        <div class="column is-3-desktop is-12-mobile">
          <label class="mb-0 has-text-centered">Data de entrega</label> 
          <div class="columns is-1">
            <div class="column is-6">
              <TrfInput
                type="date"
                placeholder="DD/MM/AAAA"
                id="prazo-entrega-inicial"
                v-model="filtroDataEntregaInicial"
                ref="inputFiltroDataEntregaInicial"
                :required="false"
              />
          </div>
          <div class="column is-6">
            <TrfInput
              type="date"
              placeholder="DD/MM/AAAA"
              id="prazo-entrega-final"
              v-model="filtroDataEntregaFinal"
              ref="inputFiltroDataEntregaFinal"
              :required="false"
            />
            <div class="mensagemDeErro">
              <span v-if="deveValidarFiltroDataEntrega && !isFiltroDataEntregaValido" class="campo-obrigatório">
                Período final deve ser maior ou igual que o período inicial.
              </span>
            </div>
          </div>
        </div>
        </div>

        <div class="column is-3-desktop is-12-mobile">
          <label class="mb-0 has-text-centered">Data de conclusão</label>
          <div class="columns is-1">
            <div class="column is-6">
              <TrfInput
                type="date"
                placeholder="DD/MM/AAAA"
                id="prazo-conclusao-inicial"
                v-model="filtroDataConclusaoInicial"
                ref="inputFiltroDataConclusaoInicial"
                :required="false"
              />
          </div>
          <div class="column is-6">
            <TrfInput
              type="date"
              placeholder="DD/MM/AAAA"
              id="prazo-conclusao-final"
              v-model="filtroDataConclusaoFinal"
              ref="inputFiltroDataConclusaoFinal"
              :required="false"
            />
            <div class="mensagemDeErro">
              <span v-if="deveValidarFiltroDataConclusao && !isFiltroDataConclusaoValido" class="campo-obrigatório">
                Período final deve ser maior ou igual que o período inicial.
              </span>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <div>
      <TrfModalCadastroTarefas
        :isModalActive="isModalActive"
        v-if="isModalActive"
        @trf-close-modal-cadastro="closeModal"
        :isTarefaAvulsa="isTarefaAvulsa"
        :listaResponsaveis="responsavelOptionsSemAgenteIA"
        :listaDepartamentos="listaDepartamentos"
        :listaDepartamentosFase="listaTodosDepartamentos"
        :listaEmpresas="listaEmpresasSemDataDeSaida"
        :listaDeModelos="listaDeModelos"
        :listaDeModelosExibicao="listaDeModelosExibicao"
        :loading="modalLoading"
        ref="modalCadastroTarefas"
        @objetoPermissoes="getDepartamentosEEmpresasSemPermissao"
        @verificaRequisicao="isPodeAbrirModal"
        @ativarModalCamposModelo="ativarModalCamposModelo"
      />
    </div>
    <TrfModal
      v-if="abreModalCamposModelo"
      idModal="trf-modal-verificar-campos-modelo"
      titulo="Importar modelo"
      btnSaveName="Sim"
      btnCloseName="Não"
      @save="importarModelo"
      @close="evitarImportacaoModelo"
      
    >
      <p>Verificamos que já existe um ou mais campos no cadastro desta tarefa. </p> <br>
      <p>Importar um modelo irá sobrescrever os dados já preenchidos. </p><br>
      <strong>Confirma a importação? </strong>
    </TrfModal>
    <div>
      <ModalDashboardPermissaoCadastro @close="closeModalPermissoes" v-if="isModalDashboardPermissaoActive & isAbreModal" :permissoesEmpresas="listaEmpresasSemPermissao" :permissoesDepartamentos="listaDepartamentosSemPermissao"/>
    </div>
    <div class="pt-2">
    <TrfTabela
      v-e2e="'tabela-historicos'"
      :tipoTabela="'tabela-historicos'"
      :dataConfig="this.dataSource"
      :data="this.historicos"
      :quantidadeDeItems="this.total"
      :nextPage="this.nextPage"
      :nextLimit="this.nextLimit"
      :isButtonMoreHidden="this.hideButtonMore"
      :showDropdownOptions="true"
      :isButtonsDisplayed="true"
      :showButtonsDefault="false"
      :dataStatus="this.status"
      :textoExclusao="textoExclusao"
      :showReabrir="true"
      :paginaSelecionada="this.pagina"
      :limiteAtual="this.limite"
      textoNadaEncontrado="Nenhuma tarefa foi encontrada."
      :showGlobalLoader="this.showGlobalLoader"
      :showEdit="false"
      :showEditarAvulsas="this.permissoesTarefas.Editar"
      :isMultipleSelection="true"
      :showConcluir="!this.permissoesTarefas || this.permissoesTarefas.Visualizar || this.isSuperAdm"
      :showDelete="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Excluir || this.isSuperAdm || this.isOperadorAdmin"
      :showTransferir="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
      :showEditarVencimento="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
      :showParalisar="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
      :showAlterarVencimento="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
      :hasSlotLine="true"
      :isToggleble="true"
      :liderancas="liderancas"
      togglebleItem="fases"
      tituloModalConclusao="Concluir tarefa"
      @update:pagina="(pagina) => this.atualizarPagina(pagina)"
      @update:limite="(limite) => this.atualizarLimite(limite)"
      @edicaoDeFasesSelected="(item) => this.iniciarModalEdicaoDeFases(item)"
      @duploClick="(item) => this.iniciarModalDetalhesHistorico(item)"
      @trfTableItemSelected="(selecao) => this.selecaoDeTarefas(selecao)"
      @trf-tabela-paralisar="paralisarTarefa"
      @trf-tabela-continuar="continuarTarefa"
      @trf-tabela-alterar-vencimento="doAbrirModalAlterarVencimento($event)"
    >
      <template #nome={item}>
        <p :title="item.nomeCompletoPai ? item.nomeCompletoPai : item.nomeCompleto">
          {{ item.nomePai? item.nomePai : item.nome }}<br />
          <span v-if="!!item.nomePai" class="is-italic" style="font-size:0.9em;">Fase: {{ item.nome }}</span>
        </p>
      </template>
      <template #slotLine={item}>
        <tr v-if="item.fases != null" class="is-togglable-row" style="background:#FFF!important">
          <td colspan="2" class="p-0 m-0"></td>
          <td colspan="6" class="p-0 m-0">
            <TrfTabela
              v-e2e="'tabela-fases'"
              :tipoTabela="'tabela-fases'"
              :containerClass="'tabela-fase-branca'"
              :isStriped="false"
              :dataConfig="getDataSourceFase(item.fases)"
              :data="item.fases"
              dataStatus=""
              :paginacao="false"
              :quantidadeDeItems="item.fases.length"
              :showDropdownOptions="true"
              :isButtonsDisplayed="true"
              :showButtonsDefault="false"
              :showReabrir="this.isSuperAdm || this.isOperadorAdmin"
              :showConcluir="!this.permissoesTarefas || this.permissoesTarefas.Visualizar || this.isSuperAdm"
              :showDelete="false"
              :showTransferir="true"
              textoNadaEncontrado="Nenhuma fase foi encontrada."
              :showEdit="false"
              :isMultipleSelection="false"
              :isSelectable="false"
              tituloModalConclusao="Concluir fase"
              :showParalisar="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
              @update:pagina="(pagina) => this.atualizarPagina(pagina)"
              @duploClick="(fase) => item.isTarefaDoLegalize && this.iniciarModalDetalhesHistorico(fase)"
              @trf-tabela-paralisar="paralisarTarefa"
              @trf-tabela-continuar="continuarTarefa"
              @trf-tabela-detalhes-fase="iniciarModalDetalhesHistorico"
            />
          </td>
        </tr>
        <tr v-if="item.fases != null"></tr>
      </template>
    </TrfTabela>
    </div>

    <TrfModal
      v-if="isModalTransferirResponsavelActive"
      idModal="trf-modal-transferir-responsavel"
      btnSaveName="Confirmar"
      :titulo="isAvulsaDoDp ? 'Transferência de departamento e/ou responsável' : 'Transferência de responsável'"
      :isBtnLoading="isModalTransferirResponsavelLoading"
      @save="async (event) => await transferirResponsavelEDepartamento(event)"
      @close="fecharModalTransferirResponsavel"
    >
      <div style="min-height: 130px">
        <TrfCardInfo
          v-if="isAvulsaDoDp"
          mensagem='Caso o departamento selecionado possua um responsável configurado na empresa, esse responsável será atribuído 
          automaticamente à tarefa se o campo "Novo responsável" não for preenchido. Caso contrário, a tarefa ficará sem um responsável.'
        />

        <div
          v-if="isAvulsaDoDp"
          class="column is-9-desktop is-12-mobile"
        >
          <label>Novo departamento</label>
          <Multiselect
            :searchable="true"
            :options="listaTodosDepartamentos"
            v-model="this.novoDepartamento"
            class="multiselect-econtador"
            placeholder="Selecione o novo departamento desta tarefa"
            noResultsText="Departamento não encontrado"
            id="select-departamento-modal-transferencia"
          />
        </div>

          <div class="column is-9-desktop is-12-mobile" >
          <label>Novo responsável</label>
          <Multiselect
            :searchable="true"
            :options="responsavelOptionsSemAgenteIA"
            v-model="this.novoResponsavel"
            class="multiselect-econtador"
            placeholder="Selecione o novo responsável pela tarefa"
            noResultsText="Responsável não encontrado"
            id="select-responsavel-modal-transferencia"
          />
        </div>
      </div>
    </TrfModal>

    <TrfSimpleModal :isAtivo="isModalPermissoes" titulo="Aviso" @close="fecharModalPermissoes" :isModalPersonalizado="true">
      <div 
        id="conteudo-modal-permissao-departamento"
        class="modal-list-content px-5 pb-1 custom-y-scrollbar"
        style="
          height: 100%;
          max-height: 60vh;
          max-width: 640px;
          width: 100%;
          overflow: auto;
        " 
      >
          <div class="content">
          <p class="mt-4">
            Identificamos que o usuário responsável vinculado a esta tarefa não possui as permissões
            necessárias para acessar a empresa e/ou departamento listado abaixo.
            Com isso as tarefas relacionadas a essa empresa e/ou departamento não estarão visíveis na
            área de dashboard do usuário.
          </p>
          <p>
            Para resolver esta situação será preciso ajustar o cadastro do usuário responsável
            concedendo a permissão a esta empresa e/ou departamento.
          </p>
          <div v-if="!this.isTemPermissaoParaDepartamentoEscolhido">
            <p>
              <strong>Departamento</strong><br>
              {{ this.departamentosSemPermissao.length != 0 ? this.departamentosSemPermissao[0].label : '' }}
            </p><p></p>
          </div>
          <div v-if="!this.isTemPermissaoParaEmpresaEscolhida">
            <p>
              <strong>Empresa</strong><br>
              {{ this.empresasSemPermissao != "" ? this.empresasSemPermissao : "" }}
            </p>
          </div>
        </div>
      </div>
    </TrfSimpleModal> 

    <TrfModal
      v-if="isModalEditarVencimentoActive"
      idModal="trf-modal-alterar-prazo"
      titulo="Alterar vencimento"
      btnSaveName="Confirmar"
      :isBtnLoading="isModalEditarVencimentoLoading"
      @save="async (event) => await editarVencimento(event)"
      @close="fecharModalEditarVencimento"
    >
      <div class="column is-12-desktop is-8-mobile">
        <div class="is-flex is-flex-direction-row">
          <label class="mr-4 mt-5">Novo prazo de entrega</label>
          
          <div class="column is-6">
            <TrfInput
              type="date"
              placeholder="DD/MM/AAAA"
              id="prazo-entrega-final"
              v-model="this.novoPrazoEntrega"
              :required="false"
            />
            <div class="mensagemDeErro">
              <span v-if="deveValidarNovoPrazoEntrega(this.novoPrazoEntrega)" class="campo-obrigatório" style="font-size: smaller;">
                {{ this.mensagemDeErroEdicaoTarefaAvulsa }}
              </span>
            </div>
          </div>
        </div>
        </div>
    </TrfModal>
    <TrfDashboardModalPermissao @on-close="(valor) => modalPermissaoDesabilitado = valor" />
    <TrfModalAlterarData 
      :isActive="isAlterarDataActive"
      :item="itemAlterarData"
      @trf-modal-alterar-data-closed="doFecharModalAlterarVencimento"
      @trf-modal-alterar-data-success="doRecarregarListagemAlteracaoVencimento"
    >
    </TrfModalAlterarData>
  </div>
</template>
<script>
import TrfHeader from "../../components/Header";
import TrfTabela from "../../components/Table";
import TrfButton from "../../components/Button";
import TrfCheckboxFields from "../../components/CheckboxFields";
import TrfButtonSelector from "../../components/ButtonSelector";
import TrfModal from "../../components/Modal";
import TrfModalCadastroTarefas from "../../components/Modal/TrfModalCadastroTarefas.vue";
import TrfSimpleModal from "../../components/Modal/TrfSimpleModal.vue";
import TrfDashboardModalPermissao from "../DashboardGestor/components/DashboardModalPermissao";
import ModalDashboardPermissaoCadastro from "../../components/Modal/ModalDashboardPermissaoCadastro.vue";
import TrfInput from "../../components/Input";
import Tarefa from "./model/historico";
import { default as TarefaModelo} from "../CadastroTarefas/model/tarefa.js";
import Multiselect from "@vueform/multiselect";
import TrfDetalhesHistorico from '../../components/DetalhesHistorico'
import TrfCardInfo  from "../../components/CardInfo";
import { service } from "./service/historico-tarefas-service";
import { usuarioService } from "../../service/usuario-service";
import { utils } from "../../util/utils";
import { acessoUtils } from "../../util/acesso.utils";
import { toastUtils } from "../../util/toast.utils.js";
import { empresasService } from "../../service/empresas-service";
import { pessoaLogada } from "../../stateManagement/pessoaLogada.js";
import { configuracoesStore } from '../../stateManagement/configuracoes.js';
import { truncateText } from "../../util/intl.js";
import { defineAsyncComponent } from "vue";
import { telemetriaService } from '../../service/telemetria-service';
import { origemTarefaEnum } from "../../enums/origemTarefaEnum.js";

export default {
  name: "Dashboard",
  components: {
    TrfHeader,
    TrfButton,
    TrfButtonSelector,
    Multiselect,
    TrfModalCadastroTarefas,
    TrfTabela,
    TrfCheckboxFields,
    TrfSimpleModal,
    TrfModal,
    TrfInput,
    TrfDetalhesHistorico,
    TrfDashboardModalPermissao,
    ModalDashboardPermissaoCadastro,
    TrfCardInfo,
    TrfFormularioEdicaoAvulsa: defineAsyncComponent(() =>
      import("../../components/FormularioEdicaoAvulsa/index.vue")
    ),
    TrfParalisarFormComponent: defineAsyncComponent(() => import("./components/paralisarFormComponent.vue")),
    TrfModalAlterarData: defineAsyncComponent(() => import("../../components/Modal/TrfModalAlterarData.vue"))
  },
  props: {
    statusTela: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      listaTodosDepartamentos: [],
      listaHistoricosDto: [],
      isModalActive: false,
      isTarefaAvulsa: true,
      responsavelId: "",
      empresaId: "",
      filtroIntervalo: "",
      filtroStatus: "",
      filtroDataEntregaInicial: null,
      filtroDataEntregaFinal: null,
      filtroDataConclusaoInicial: null,
      filtroDataConclusaoFinal: null,
      dataSource: {
        columns: [
          {
            name: "nome",
            label: "Nome da tarefa",
            style: "width:25%",
            slot: true
          },
           {
            name: "andamento",
            label: "Andamento"
          },
          {
            name: "dataCompetencia",
            label: "Competência",
            style: "white-space:nowrap",
            style: "width:10%",
          },
          {
            name: "empresa.nomeFormatado",
            label: "Empresa",
            style: "width:20%",
          },
          {
            name: "data",
            label: "Data de entrega",
            style: "white-space:nowrap",
          },
          {
            name: "dataConclusao",
            label: "Data de conclusão",
            style: "white-space:nowrap",
          },
          {
            name: "status",
            label: "Status",
            style: "white-space:nowrap",
            classe: true,
          },
        ],
        selected: null,
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        filter: () => this._carregarListagem(),
        delete: (item) => this.excluir(item),
        preDelete: (item) => this.atribuirTextoExclusao(item),
        disableCondition: (item) => item.status == 'Concluído',
        shareResponsavelEDepartamento: (item) => {
          this.isAvulsaDoDp = this.isAvulsa(item) && !origemTarefaEnum.DEPARTAMENTO_PESSOAL.equals(item.origemTarefa) && !item.isFase;
          this.objetoHistorico = item
          this.historicoTarefaIdParaTransferirResponsavel = item.isFase ? null : item.id;
          this.faseIdParaTransferirResponsavel = item.isFase ? item.faseId : null;
          this.abrirModalTransferirResponsavel()
        },
        editarVencimento: (item) => {
          this.historicoTarefaIdParaEditarVencimentoTarefaAvulsa = item.id
          this.abrirModalEditarVencimento()
        },
        concluirTarefa: (item) => this.concluirTarefa(item),
        loadMore: null,
      },
      historicos: [],
      todasAsEmpresas: [],
      cadastrandoOuEditando: false,
      item: new Tarefa(),
      editando: false,
      status: this.statusTela,
      hideButtonMore: false,
      listagemVisivel: true,
      showTitle: false,
      pagina: 1,
      total: 0,
      limite: 10,
      responsavelOptions: [],
      intervalosOptions: [],
      statusOptions: [],
      listaDepartamentos: [],
      listaEmpresas: [],
      listaEmpresasSemDataDeSaida: [],
      nomeTarefa: "",
      departamentoId: "",
      textoExclusao: "",
      modalLoading: {
        conteudo: false,
        campoEmpresas: true,
        campoResponsavel: true,
        campoDepartamento: true,
        campoRecorrencia: true,
        realizandoEdicao: false
      },
      showGlobalLoader: true,
      permissoesTarefas: pessoaLogada.getPermissoes("Tarefas"),
      isSuperAdm: pessoaLogada.current.isSuperAdm,
      isOperadorAdmin: pessoaLogada.current.Administrador,
      isModalDetalhesHistoricoAtivo: false,
      tituloModalDetalhesHistorico: "",
      detalhesHistorico: null,
      tarefasSelecionadas: [],
      isModalConcluirActive: false,
      isModalConcluirLoading: false,
      activarFiltroAvancado: false,
      isModalExcluirEmBlocoActive: false,
      isModalExcluirEmBlocoLoading: false,
      isModalTransferirResponsavelActive: false,
      isModalTransferirResponsavelLoading: false,
      novoResponsavel: "",
      novoDepartamento: "",
      historicoTarefaIdParaTransferirResponsavel: null,
      faseIdParaTransferirResponsavel: null,
      isModalEditarVencimentoActive: false,
      historicoTarefaIdParaEditarVencimentoTarefaAvulsa: null,
      novoPrazoEntrega: null,
      mensagemDeErroEdicaoTarefaAvulsa: "",
      operadorLogadoSuperAdmOuAdm: false,
      objetoHistorico: {},
      isModalPermissoes: false,
      departamentosSemPermissao: [],
      empresasSemPermissao: "",
      isTemPermissaoParaDepartamentoEscolhido: true,
      isTemPermissaoParaEmpresaEscolhida: true,
      listaEmpresasSemPermissao: [],
      listaDepartamentosSemPermissao: [],
      isModalDashboardPermissaoActive: false,
      isAbreModal: false,
      abreModalCamposModelo: false,
      listaDeModelos: [],
      listaDeModelosExibicao: [],
      isModalEdicaoDeFasesActive: false,
      avulsaEmEdicao: new TarefaModelo(),
      modeloEmEdicao: null,
      modalEdicaoAtivo: '',
      errosDePermissao: [],
      modeloImportado: false,
      dataSourceErroPermissao: {
        columns: [
          {
            name: 'faseHistorico.ordem',
            label: 'Ordem'
          },
          {
            name: 'faseHistorico.nome',
            label: 'Fase'
          },
          {
            name: 'nomeResponsavel',
            label: 'Responsavel'
          }
        ],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        delete: async (item) => this.removerAnexo(item)
      },
      tituloModalPausar: 'Paralisar tarefa',
      isModalPausarAtivo: false,
      tituloModalContinuar: 'Continuar tarefa',
      isModalContinuarAtivo: false,
      itemEmAcesso: null,
      isBtnModalLoading: false,
      isBtnExportarPlanilhaLoading: false,
      liderancas: [],
      isAlterarDataActive: false,
      itemAlterarData: null,
      origemTarefaEnum: origemTarefaEnum,
      isAvulsaDoDp: false
    };
  },
  computed: {
    responsavelOptionsSemAgenteIA() {
      if (!Array.isArray(this.responsavelOptions)) return [];
      return this.responsavelOptions.filter(r => r.agenteIaId == null);
    },
    tituloModalEdicaoAvulsa() {
      if(!this.modalEdicaoAtivo) {
        return 'Editar modelo e/ou fases'
      } else if (this.modalEdicaoAtivo == 'permissao') {
        return 'Conceder permissão'
      } else {
        return 'Importar modelo';
      }
    },
    recorrenciaEnum() {
      const recorrencias = {
        ANUAL: 1,
        MENSAL: 2,
        TRIMESTRAL: 3,
        SEMESTRAL: 4,
        DECENDIAL: 5,
        SEMANAL: 6
      }
      return recorrencias;
    },
    filtrosRequisicaoHistorico() {
      let filtroDeData = {};
      if(this.isFiltroDataConclusaoValido) {
        const dataConclusaoInicialFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataConclusaoInicial);
        const dataConclusaoFinalFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataConclusaoFinal);
        filtroDeData = {
          "dataInicial": dataConclusaoInicialFormatada,
          "dataFinal": dataConclusaoFinalFormatada,
          "dataConclusao[ge]": dataConclusaoInicialFormatada,
          "dataConclusao[le]": dataConclusaoFinalFormatada
        }
      } else if(this.isFiltroDataEntregaValido) {
        const dataEntregaInicialFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataEntregaInicial);
        const dataEntregaFinalFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataEntregaFinal);
        filtroDeData = {
          "dataInicial": dataEntregaInicialFormatada,
          "dataFinal": dataEntregaFinalFormatada,
          "prazoEntrega[ge]": dataEntregaInicialFormatada,
          "prazoEntrega[le]": dataEntregaFinalFormatada
        }
      } else {
        filtroDeData = {
          "dataInicial": this.filtroIntervalo?.value.dataInicial || "",
          "dataFinal": this.filtroIntervalo?.value.dataFinal || ""
        }
      }
      const objetoDeFiltro = {
        "sort[ASC]": "prazoEntrega,id",
        status: this.filtroStatus || "",
        empresaId: this.empresaId || "",
        "nome[iLike]": `%${this.nomeTarefa}%` || "",
        pagina: this.pagina || 1,
        limit: this.limite || 10,
        ...filtroDeData,
        "tarefaCliente": false
      };

      this.responsavelId == "sem responsavel"
        ? (objetoDeFiltro["responsavelId[is]"] = null)
        : (objetoDeFiltro.responsavelId = this.responsavelId || "");

      if(!!this.departamentoId) {
        this.departamentoId.includes("P") 
        ? (objetoDeFiltro.departamentoPadrao = this.departamentoId.replace("P", "") || "")
        : (objetoDeFiltro.departamento = this.departamentoId || "");
      }

      return objetoDeFiltro;
    },
    optionsFilterResponsavel() {
      let responsaveisTratados;
      if(!!!this.operadorLogadoSuperAdmOuAdm) {
        const responsavelLogadoUWD = acessoUtils.adquirirUWDDoUsuarioLogado();
        responsaveisTratados = this.responsavelOptions.filter(responsavel => {
          return responsavel.value == responsavelLogadoUWD;
        })
        let isPresent = false;
        this.responsavelOptions?.forEach((element) => {
          responsaveisTratados[0]?.idsDepartamentosResponsavel?.forEach((idDeDepartamento)=>{
            isPresent = element?.idDoResponsavelDoHistorico?.some(
              idDepartamentoHistorico => idDepartamentoHistorico == idDeDepartamento
            )
            if (isPresent) {
              if (responsaveisTratados[0].value != element.value) {
                responsaveisTratados.push(element)
              }
            }  
          });  
        });
      } else {
        responsaveisTratados = this.responsavelOptions;
      }
      const OptionsParaFiltro = [
        { value: "sem responsavel", label: "Sem Responsável" },
        ...responsaveisTratados
      ];
      return OptionsParaFiltro
    },
    deveValidarFiltroDataEntrega() {
      return !!this.filtroDataEntregaInicial || !!this.filtroDataEntregaFinal;
    },
    isFiltroDataEntregaValido() {
      const filtroInicialAsDate = new Date(this.filtroDataEntregaInicial);
      const filtroFinalAsDate = new Date(this.filtroDataEntregaFinal);

      const isDataEntregaPreenchida = !!this.filtroDataEntregaInicial && !!this.filtroDataEntregaFinal;
      const isDataEntregaValida = filtroInicialAsDate instanceof Date && isNaN(this.filtroDataEntregaInicial) && filtroFinalAsDate instanceof Date && isNaN(this.filtroDataEntregaFinal);
      const isIntervaloValido = this.filtroDataEntregaFinal >= this.filtroDataEntregaInicial;
      
      return isDataEntregaPreenchida && isDataEntregaValida && isIntervaloValido;
    },
    deveValidarFiltroDataConclusao() {
      return !!this.filtroDataConclusaoInicial || !!this.filtroDataConclusaoFinal;
    },
    isFiltroDataConclusaoValido() {
      const filtroInicialAsDate = new Date(this.filtroDataConclusaoInicial);
      const filtroFinalAsDate = new Date(this.filtroDataConclusaoFinal);

      const isDataEntregaPreenchida = !!this.filtroDataConclusaoInicial && !!this.filtroDataConclusaoFinal;
      const isDataEntregaValida = filtroInicialAsDate instanceof Date && isNaN(this.filtroDataConclusaoInicial) && filtroFinalAsDate instanceof Date && isNaN(this.filtroDataConclusaoFinal);
      const isIntervaloValido = this.filtroDataConclusaoFinal >= this.filtroDataConclusaoInicial;
      
      return isDataEntregaPreenchida && isDataEntregaValida && isIntervaloValido;
    }
  },
  methods: {
    async adquirirDepartamentoService() {
      const { departamentoService } = await import('../../service/departamento-service.js');
      return departamentoService;
    },
    async adquirirServiceDePermissao() {
      const { permissaoService } = await import(
        "../../service/permissao-service"
      );
      return permissaoService;
    },
    async tarefaParalisadaCallback() {
      this.fecharModalPausar(); 
      await this.$nextTick();
      await this._carregarListagem(true)
    },
    setBtnModalLoading(loadingStatus) {
      this.isBtnModalLoading = loadingStatus
    },
    paralisarTarefa(item, evento) {
      this.abrirModalPausar(item)
    },
    continuarTarefa(item, evento) {
      this.abrirModalContinuar(item)
    },
    doParalisarTarefa() {
      this.isBtnModalLoading = true
      this.$refs.paralisarForm.doAction()
    },
    async doContinuarTarefa() {
      this.isBtnModalLoading = true
      try {
        if (!this.itemEmAcesso) throw "Item da ação não encontrado";
        const historicoId = this.itemEmAcesso.historicoTarefaId? this.itemEmAcesso.historicoTarefaId : this.itemEmAcesso.id;
        const faseId = this.itemEmAcesso.faseId? this.itemEmAcesso.faseId : null;
        const result = await service.continuarHistorico(historicoId, faseId);
        toastUtils.successToast(`${this.itemEmAcesso.faseId? "Fase" : "Tarefa"} continuada com sucesso!`);
        this.fecharModalContinuar();
        this._carregarListagem(true)
      } catch (e) {
        console.warn(e);
        toastUtils.dangerToast(`Não foi possível continuar com a ${this.itemEmAcesso.faseId? "Fase" : "Tarefa"}!`);
      }
      this.isBtnModalLoading = false
    },
    async confirmacaoModalEdicaoAvulsa() {
      if (!this.modalEdicaoAtivo) {
        await this.encadearEdicaoAvulsa();
      } else if (this.modalEdicaoAtivo == 'permissao') {
        await this.concederPermissaoParaTarefaAtual();
      } else if (this.modalEdicaoAtivo == 'resetarModelo') {
        this.$refs.formularioEdicao.resetarFormulario();
        this.modalEdicaoAtivo = '';
        this.modeloImportado = false;
      } else {
        this.$refs.formularioEdicao.importarModeloSelecionado();
        this.modalEdicaoAtivo = '';
      }
    },
    async concederPermissaoParaTarefaAtual() {
      try {
        this.modalLoading.realizandoEdicao = true;
        const permissaoService = await this.adquirirServiceDePermissao();
        const tarefaProxy = Object.assign({}, this.modeloEmEdicao);
        const concederPermissoes = await permissaoService.atualizarPermissaoEdicaoAvulsa(
          tarefaProxy
        );
        await this.efetuarEdicaoAvulsa();
      } catch (e) {
        this.modalLoading.realizandoEdicao = false;
      }
    },
    async encadearEdicaoAvulsa() {
      if(!this.$refs.formularioEdicao.checkValidity(true)) return;
      try {
        this.modalLoading.realizandoEdicao = true;
        const permissaoService = await this.adquirirServiceDePermissao();
        const tarefaProxy = Object.assign({}, this.modeloEmEdicao);
        const validacoesDePermissao = await permissaoService.verificarPermissaoEdicaoAvulsa(
          tarefaProxy
        );    
        this.errosDePermissao = this.montarListagemErrosDePermissao(
          validacoesDePermissao
        );
        const temErrosDePermissao = validacoesDePermissao.length > 0;
        if (temErrosDePermissao) {
          this.modalLoading.realizandoEdicao = false;
          this.modalEdicaoAtivo = 'permissao'
        } else {
          await this.efetuarEdicaoAvulsa()
        }
      } catch (e) {
        this.modalLoading.realizandoEdicao = false;
      }
    },
    async efetuarEdicaoAvulsa() {
      try {
        this.modalLoading.realizandoEdicao = true;
        await service.editarAvulsa(this.modeloEmEdicao, this.modeloImportado);
        this.modalEdicaoAtivo = '';
        this.cancelamentoModalEdicaoAvulsa();
        this._carregarListagem();
        this.modalLoading.realizandoEdicao = false;
        this.modeloImportado = false;
      } catch (e) {
        toastUtils.dangerToast(`Não foi possível realizar a edição, tente novamente.`);
        this.modalLoading.realizandoEdicao = false;
        this.modeloImportado = false;
      }
    },
    cancelamentoModalEdicaoAvulsa() {
      if (!this.modalEdicaoAtivo) {
        this.modalEdicaoAtivo = '';
        this.isModalEdicaoDeFasesActive = false;
        this.avulsaEmEdicao = null;
        this.modeloEmEdicao = null;
        this.modeloImportado = false;
        this.$refs.formularioEdicao.limparFormulario();
      } else if (this.modalEdicaoAtivo == 'permissao') {
        this.errosDePermissao = [];
        this.modalEdicaoAtivo = '';
      } else { 
        this.modalEdicaoAtivo = ''; 
      }
    },
    atualizarValoresEdicao(valores) {
      this.modeloEmEdicao = Object.assign({}, valores);
    },
    montarListagemErrosDePermissao(falhasDePermissao) {
      if (!Array.isArray(falhasDePermissao)) {
        return [];
      }
      const listaOrdenada = [];
      falhasDePermissao.forEach((falha) => {
        if (
          !listaOrdenada.some((item) => {
            const isOrdemMatch = falha.faseHistorico.ordem == item.faseHistorico.ordem;
            const isNomeMatch = falha.faseHistorico.nome == item.faseHistorico.nome;
            const isResponsavelMatch =
              falha.nomeResponsavel == item.nomeResponsavel;
            return isOrdemMatch && isNomeMatch && isResponsavelMatch;
          })
        ) {
          listaOrdenada.push(falha);
        }
      });
      listaOrdenada.sort((a, b) => {
        if (a.faseHistorico.ordem !== b.faseHistorico.ordem) {
          return a.faseHistorico.ordem - b.faseHistorico.ordem;
        }
        if (a.faseHistorico.nome < b.faseHistorico.nome) return -1;
        if (a.faseHistorico.nome > b.faseHistorico.nome) return 1;
        return 0;
      });

      return listaOrdenada;
    },
    getDataSourceFase(fases) {
      const dataSource = {
        columns: [
          {
            name: "nome",
            label: "Nome da fase",
            style: "width:25%",
          },
          {
            name: "departamento",
            label: "Departamento",
            style: "width:16%",
          },
          {
            name: "responsavel",
            label: "Responsável",
            style: "width:16%",
          },
          {
            name: "data",
            label: "Data de entrega",
            style: "white-space:nowrap",
          },
          {
            name: "dataConclusao",
            label: "Data de conclusão",
            style: "white-space:nowrap",
          },
          {
            name: "status",
            label: "Status",
            style: "white-space:nowrap",
            classe: true,
          },
        ],
        selected: null,
        itens: !!fases? fases : [],
        itensSelected: [],
        itensDisabled: [],
        filter: () => {},
        delete: (item) => this.excluir(item),
        preDelete: (item) => this.atribuirTextoExclusao(item),
        shareResponsavelEDepartamento: (item) => {
          this.isAvulsaDoDp = this.isAvulsa(item) && !origemTarefaEnum.DEPARTAMENTO_PESSOAL.equals(item.origemTarefa) && !item.isFase;
          this.objetoHistorico = item;
          this.faseIdParaTransferirResponsavel = item.isFase ? item.faseId : null
          this.abrirModalTransferirResponsavel()
        },
        concluirTarefa: (item) => this.concluirTarefa(item),
        loadMore: null,
      };
      return dataSource;
    },
    tratarFiltroIntervalo(novoValor) {
      this.filtroIntervalo = novoValor;
      if(this.filtroIntervalo != null) {
        this.filtroDataEntregaInicial = null;
        this.filtroDataEntregaFinal = null;
        this.filtroDataConclusaoInicial = null;
        this.filtroDataConclusaoFinal = null;
      }
    },

    abrirModalConclusao() {
      this.isModalConcluirActive = true;
    },

    async concluirTarefasEmBloco() {
      this.isModalConcluirLoading = true;

      const motivo = this.$refs.trfConclusaoMotivo.value;
      const ids = this.tarefasSelecionadas.map(tarefa => tarefa.id);

      const request = await service.baixarMultiplas(ids, motivo);

      if (request.ok) {
        this.atualizarPagina(this.pagina);
      };

      this.isModalConcluirLoading = false;

      this.fecharModalConclusao();
    },

    async concluirTarefa(tarefa) {
      let motivoConclusao = document.querySelector("#motivo-conclusao")?.value;

      let item = tarefa;
      let success;

      if (item.isFase) {
        let faseId = item.faseId ? item.faseId : item.id;
        success = await service.concluir(item.historicoTarefaId, faseId, motivoConclusao, false);
      } else {
        success = await service.concluir(item.id, null, motivoConclusao);
      }

      if (success) {
        this.atualizarPagina(this.pagina);
        telemetriaService.cadastrarTelemetria('/baixar');
      }
    },

    fecharModalConclusao() {
      this.$refs.trfConclusaoMotivo.value = "";
      this.isModalConcluirActive = false;
    },

    abrirModalExclusaoEmBloco() {
      this.isModalExcluirEmBlocoActive = true;
    },

    async excluirTarefasEmBloco() {
      this.isModalExcluirEmBlocoLoading = true;

      const motivo = this.$refs.trfExclusaoMotivo.value;
      const ids = this.tarefasSelecionadas.map(tarefa => tarefa.id);
      
      const request = await service.excluirMultiplas(ids, motivo);

      if (request.ok) {
        this.atualizarPagina(this.pagina);
      };

      this.isModalExcluirEmBlocoLoading = false;

      this.fecharModalExclusaoEmBloco();
    },

    fecharModalExclusaoEmBloco() {
      this.$refs.trfExclusaoMotivo.value = "";
      this.isModalExcluirEmBlocoActive = false;
    },

    selecaoDeTarefas(selecao) {
      this.tarefasSelecionadas = selecao;
    },

    async openModal() {
      this.isModalActive = true;
      this.listarEmpresasSemDataDeSaida();
    },

    closeModal() {
      this.isModalActive = false;
    },

    podeRealizarBaixa() {
      const podeEditar =  this.isOperadorAdmin || this.permissoesTarefas?.Visualizar || this.isSuperAdm;
      const temTarefasSelecionadas = this.tarefasSelecionadas.length > 0;
      return podeEditar && temTarefasSelecionadas;
    },

    podeRealizarTransferenciaMultipla() {
      const podeEditar =  this.isOperadorAdmin || this.permissoesTarefas?.Editar || this.isSuperAdm;
      const temTarefasSelecionadas = this.tarefasSelecionadas.length > 0;
      return podeEditar && temTarefasSelecionadas;
    },

    podeRealizaExclusaoMultipla() {
      const podeExcluir = this.isOperadorAdmin || this.permissoesTarefas?.Excluir || this.isSuperAdm;
      const temTarefasSelecionadas = this.tarefasSelecionadas.length > 0;
      const temTarefaDeFases = this.tarefasSelecionadas.some(element => element?.isFase);
      return podeExcluir && temTarefasSelecionadas && !temTarefaDeFases; 
    },

    abrirModalTransferirResponsavel() {
      this.isModalTransferirResponsavelActive = true;
      this.preencherSelectDeTransferenciaComValores();
    },

    preencherSelectDeTransferenciaComValores() {
      let departamentoSelecionado = this.listaDepartamentos.find(element => element.label === this.objetoHistorico.departamento);
      let responsavelSelecionado = this.responsavelOptions.find(element => element.label === this.objetoHistorico.responsavel);

      if (responsavelSelecionado) {
          this.novoResponsavel = responsavelSelecionado.value;
      }

      if(departamentoSelecionado) {
        this.novoDepartamento = parseInt(departamentoSelecionado.value);
      }
    },

    abrirModalTransferirResponsavelSelecionadas() {
      this.isModalTransferirResponsavelActive = true;
    },

    async closeModalPermissoes() {
      this.isModalDashboardPermissaoActive = false;
      window.location.reload(true);
    },
    
    abrirModalEditarVencimento() {
      this.isModalEditarVencimentoActive = true;
    },

    fecharModalTransferirResponsavel() {
      this.isModalTransferirResponsavelActive = false;
      this.novoResponsavel = "";
      this.novoDepartamento = "";
      this.historicoTarefaIdParaTransferirResponsavel = null;
      this.faseIdParaTransferirResponsavel = null;
      this.isAvulsaDoDp = false;
    },
    abrirModalPausar(item) {
      this.tituloModalPausar = "Paralisar tarefa"
      if (item.isFase) {
        this.tituloModalPausar = "Paralisar fase"
      }
      this.itemEmAcesso = item
      this.isModalPausarAtivo = true
    },
    abrirModalContinuar(item) {
      this.tituloModalContinuar = "Continuar tarefa"
      if (item.isFase) {
        this.tituloModalContinuar = "Continuar fase"
      }
      this.itemEmAcesso = item
      this.isModalContinuarAtivo = true
    },
    fecharModalPausar() {
      this.$refs.paralisarForm.doCancel()
      this.itemEmAcesso = null
      this.isModalPausarAtivo = false
      this.isBtnModalLoading = false
    },
    fecharModalContinuar() {
      this.isModalContinuarAtivo = false
      this.isBtnModalLoading = false
    },
    fecharModalEditarVencimento() {
      this.isModalEditarVencimentoActive = false;
      this.novoPrazoEntrega = null;
      this.historicoTarefaIdParaEditarVencimentoTarefaAvulsa = null;
      this.isModalEditarVencimentoLoading = false;
    },

    async transferirResponsavelEDepartamento() {
      this.isModalTransferirResponsavelLoading = true;

      let request = {};

      if(this.historicoTarefaIdParaTransferirResponsavel || this.faseIdParaTransferirResponsavel) {
        this.setaValorPadraoDepartamentoSeTiverNulo();
        this.setaValorPadraoResponsavelSeTiverNulo();

        if (this.novoResponsavel != "" && this.novoResponsavel != null) {
          const responsavel = await usuarioService.getResponsavel(this.novoResponsavel);
          this.montaObjetoEmpresaPermissoes(responsavel);
          this.montaObjetoDepartamentoPermissoes(responsavel);
        }
        
        const departamentoId = this.novoDepartamento == "" ? "" : parseInt(this.novoDepartamento)

        const id = [];
        const fasesId = [];
        if (!!this.historicoTarefaIdParaTransferirResponsavel) {
          id.push(this.historicoTarefaIdParaTransferirResponsavel);
        }
        if (!!this.faseIdParaTransferirResponsavel) {
          fasesId.push(this.faseIdParaTransferirResponsavel);
        }
        request = await service.transferirResponsavelEDepartamento(id, this.novoResponsavel, departamentoId, fasesId, true);
        if (request.ok) {
          if (!this.isTemPermissaoParaDepartamentoEscolhido || !this.isTemPermissaoParaEmpresaEscolhida) {
            this.isModalPermissoes = true;
            this.pegaDepartamentosSemPermissao();
            this.pegaEmpresasSemPermissao();
          } else {
            this.atualizarPagina(this.pagina);
          }
        }
      } else if (this.tarefasSelecionadas.length > 0) {
        let idsFases = [];
        const idsTarefas = [];
        this.tarefasSelecionadas.forEach(tarefa =>{
          if(tarefa.id != null){
            idsTarefas.push(tarefa.id)
            return;
          }
          idsFases.push(tarefa.faseId)
        })
        
        const ids = idsTarefas.filter((id) => id);
      
        request = await service.transferirResponsavelEDepartamento(ids, this.novoResponsavel, this.novoDepartamento, idsFases, false);

        this.atualizarPagina(this.pagina);
      }
      
      this.isModalTransferirResponsavelLoading = false;
      this.fecharModalTransferirResponsavel();
    },
    async editarVencimento() {
      if (this.deveValidarNovoPrazoEntrega(this.novoPrazoEntrega) || this.novoPrazoEntrega == null) {
        toastUtils.dangerToast("Novo prazo de entrega inválido!");
        return;
      }

      this.isModalEditarVencimentoLoading = true;

      let request = await service.editarVencimentoTarefaAvulsa(this.historicoTarefaIdParaEditarVencimentoTarefaAvulsa, this.novoPrazoEntrega);
      
      if (request.ok) {
        this.atualizarPagina(this.pagina);
      };

      this.isModalEditarVencimentoActive = false;
      this.isModalEditarVencimentoLoading = false;
      this.fecharModalEditarVencimento();
    },

    async _carregarListagem(reiniciarPaginacao) {
      if(this.deveValidarFiltroDataEntrega && !this.isFiltroDataEntregaValido) {
        toastUtils.dangerToast("Filtro de data de entrega inválido!");
        return;
      }
      if(this.deveValidarFiltroDataConclusao && !this.isFiltroDataConclusaoValido) {
        toastUtils.dangerToast("Filtro de data de conclusão inválido!");
        return;
      }
      this.showGlobalLoader = true;
      try {
        if (!!reiniciarPaginacao) {
          this.pagina = 1;
        }
        let listaDeHistoricos = await service.listarHistorico(this.filtrosRequisicaoHistorico);
        if (
          !!!reiniciarPaginacao &&
          this._validarNecessidadeDeTrocaDePagina(parseInt(listaDeHistoricos.totalDePaginas), this.pagina)
        ) {
          this.pagina = listaDeHistoricos.totalDePaginas;
          this._carregarListagem();
          return;
        }

        this.total = parseInt(listaDeHistoricos.totalDeItens);

        if (this.total === 0) {
          this.status = "is-empty";
        } else {
          this.historicos = this._converterHistoricoEmHistoricoDto(listaDeHistoricos);
          this.status = "";
        }
      } catch (e) {
        console.warn(`WARN: ${e}`)
        this.status = "is-danger";
      }
      this.showGlobalLoader = false;
    },

    atribuirTextoExclusao(tarefa) {
      if (tarefa.status == "Concluído") {
        return toastUtils.dangerToast(`${tarefa.isFase? "Fases" : "Tarefas"} com status "Concluído" não podem ser excluídas.`);
      }
      if(tarefa.fases != null) {
        this.textoExclusao = `Deseja excluir a tarefa <strong>${tarefa.nome}</strong> do período ${tarefa.data}?<br/><br/><strong>Atenção:</strong> Ao clicar em confirmar, as fases correspondentes a esta tarefa também serão excluídas.`
      } else if (tarefa.isFase) {
        this.textoExclusao = `Deseja excluir a fase <strong>${tarefa.nome}</strong> do período ${tarefa.data}?`; 
      } else {
        this.textoExclusao = `Deseja excluir a tarefa <strong>${tarefa.nome}</strong> do período ${tarefa.data}?`;
      }
    },

    async excluir(tarefa) {
      try {
        const resposta = await service.delete(tarefa);

        if (resposta.ok) {
          toastUtils.successToast(`${tarefa.isFase? "Fase" : "Tarefa"} excluída com sucesso!`);
          const itemIndex = this.historicos.findIndex((item) => item.id === tarefa.id);
          this.historicos.splice(itemIndex, 1);
        }
      } catch (e) {
        toastUtils.dangerToast(`Erro ao tentar excluir a ${tarefa.isFase? "fase" : "tarefa"}!`);
      }
    },

    _validarNecessidadeDeTrocaDePagina(totalDePaginas, pagina) {
      if (totalDePaginas == 0) return false;
      return totalDePaginas < pagina;
    },

    async nextPage(pagina) {
      this.pagina = pagina;

      this._carregarListagem();
    },
    async nextLimit(limite) {
      this.limite = limite;
      this._carregarListagem();
    },

    _converterHistoricoEmHistoricoDto(listaDeHistoricos) {
      this.listaHistoricosDto = [];
      listaDeHistoricos.data.forEach((historico) => {
        if (this.verificarTipoUsuarioETarefaDeFases(historico)) {
          const historicosDto = this.montarObjetoHistoricoDto(historico);
          this.listaHistoricosDto.push(historicosDto);
        } else {
          const fases = historico.fases;
          fases.sort((a,b) => {
            // Primeiro ordena por ordem (crescente)
            if (a.ordem !== b.ordem) {
              return a.ordem - b.ordem;
            }
            // Se a ordem for igual, ordena alfabeticamente pelo nome
            if (a.nome < b.nome) return -1;
            if (a.nome > b.nome) return 1;
            return 0;
          })
          fases.forEach((fase) => {
            const faseDto = this.montarObjetoFaseDto(historico, fase);
            this.listaHistoricosDto.push(faseDto);
          })
        }
      });
      return this.listaHistoricosDto;
    },

    adquirirNomeDepartamento(historico) {
      const hasDepartamento = historico?.departamento;
      const hasDepartamentoPadrao = historico?.departamentoPadrao?.nome;
      if (hasDepartamento) {
        return historico.departamento?.nome;
      }
      if (hasDepartamentoPadrao) {
        return historico?.departamentoPadrao?.nome
      }
      return "---"
    },

    exibirDepartamentoTabelaFase(item) {
      if (!!!item.departamentoId) return "---";
      const departamento = this.listaDepartamentos.find((departamento) => {
        return departamento.value == item.departamentoId;
      });
      return !!!departamento?.label ? "---" : departamento.label;
    },

    montarObjetoHistoricoDto(historico) {
      const prazoDeEntregaFormatado = utils.formatarDataParaExibicaoNoDataTable(historico.prazoEntrega);
      const historicosDto = {
        id: historico.id,
        nome: truncateText(historico.nome,49),
        nomeCompleto: historico.nome,
        empresa: this._montarNomeDaEmpresaFormatado(historico.empresa),
        data: prazoDeEntregaFormatado,
        dataConclusao: !!historico.dataConclusao?
            utils.formatarDataParaExibicaoNoDataTable(historico.dataConclusao) : 
            '---',
        status: historico.status.nome,
        statusId: historico.status.id,
        responsavel: historico.responsavel?.nome ? historico.responsavel.nome : '---',
        responsavelId: historico.responsavelId,
        departamento: this.adquirirNomeDepartamento(historico),
        departamentoId: historico.departamento?.id,
        prazoLegal: utils.formatarDataParaExibicaoNoDataTable(historico.prazoLegal),
        observacoes: historico.descricao,
        competencia: historico.competencia,
        recorrencia: historico.recorrencia,
        textoPeriodoReferencia: historico.textoPeriodoReferencia,
        dataAberturaTarefa: historico.dataAberturaTarefa,
        dataCompetencia: this.gerarDataCompetencia(prazoDeEntregaFormatado, historico),
        fases: historico.fases,
        isAdmin: (this.isSuperAdm || this.isOperadorAdmin),
        geraMulta: historico.geraMulta,
        isTarefaDeAtendimento: historico.isTarefaDeAtendimento,
        isTarefaDoLegalize: historico.isTarefaDoLegalize,
        tipoDeTarefaId: historico.tipoDeTarefaId,
        atendimentoId: historico.atendimentoId,
        documentoId: historico.documentoId,
        isAlgumaFaseParalisada: historico.isAlgumaFaseParalisada,
        isAlgumaFaseConcluida: historico.isAlgumaFaseConcluida,
        isAlgumaFaseEnviada: historico.isAlgumaFaseEnviada,
        desativarConclusaoManual: historico.desativarConclusaoManual,
        andamento: `${historico.andamento}%`,
        origemTarefa: origemTarefaEnum.getByKey(historico.origemTarefa)
      };

      if(historico.recorrencia?.id == this.recorrenciaEnum.DECENDIAL) {
        historicosDto.tipoDecendio = historico.tipoDecendio;
      }

      if(historicosDto.fases != null) {
        historicosDto.fases.forEach((fase) => {
          const responsavel = this.responsavelOptions.find(responsavel => {
            return responsavel.value == fase.responsavelId;
          })
          fase.faseId = fase.id,
          fase.departamentoId = fase?.departamentoId,
          fase.departamento = this.exibirDepartamentoTabelaFase(fase),
          fase.data = prazoDeEntregaFormatado, //Esta linha precisará ser alterada futuramente
          fase.empresa = this._montarNomeDaEmpresaFormatado(historico.empresa),
          fase.dataConclusao = !!fase.dataConclusao?
            utils.formatarDataParaExibicaoNoDataTable(fase.dataConclusao) : 
            '---',
          fase.statusId = fase.status.id,
          fase.status = fase.status.nome,
          fase.responsavel = responsavel?.label ? responsavel.label : '---',
          fase.podeConcluir = fase.podeConcluir,
          fase.isFase = true,
          fase.isAdmin = (this.isSuperAdm || this.isOperadorAdmin)
          fase.isTarefaDoLegalize = historico.isTarefaDoLegalize
          fase.textoPeriodoReferencia = historico.textoPeriodoReferencia
          fase.prazoLegal = utils.formatarDataParaExibicaoNoDataTable(historico.prazoLegal)
        });

        historicosDto.fases.sort((a,b) => {
          if (a.ordem !== b.ordem) {
            return a.ordem - b.ordem;
          }
          if (a.nome < b.nome) return -1;
          if (a.nome > b.nome) return 1;
          return 0;
        });
      };

      return historicosDto;
    },

    montarObjetoFaseDto(historico, fase) {
      const prazoDeEntregaFormatado = utils.formatarDataParaExibicaoNoDataTable(historico.prazoEntrega);
      const responsavel = this.responsavelOptions.find(responsavel => {
        return responsavel.value == fase.responsavelId;
      })
      historico.isFase = true;
      
      const fasesDto = {
        historicoTarefaId: fase.historicoTarefaId,
        faseId: fase.id,
        nome: truncateText(fase.nome,49),
        nomeCompleto: fase.nome,
        nomePai: truncateText(historico.nome,49),
        nomeCompletoPai: historico.nome,
        empresa: this._montarNomeDaEmpresaFormatado(historico.empresa),
        data: prazoDeEntregaFormatado,
        dataConclusao: !!fase.dataConclusao?
                  utils.formatarDataParaExibicaoNoDataTable(fase.dataConclusao) : 
                  '---',
        status: fase.status.nome,
        statusId: fase.status.id,
        responsavel: fase.responsavel = responsavel?.label ? responsavel.label : '---',
        departamentoId: fase?.departamentoId,
        departamento: this.exibirDepartamentoTabelaFase(fase),
        prazoLegal: utils.formatarDataParaExibicaoNoDataTable(historico.prazoLegal),
        observacoes: historico.descricao,
        competencia: historico.competencia,
        recorrencia: historico.recorrencia,
        textoPeriodoReferencia: historico.textoPeriodoReferencia,
        dataAberturaTarefa: historico.dataAberturaTarefa,
        dataCompetencia: this.gerarDataCompetencia(prazoDeEntregaFormatado, historico),
        isTarefaDeAtendimento: historico.isTarefaDeAtendimento,
        tarefaDeFases: true,
        isAdmin: (this.isSuperAdm || this.isOperadorAdmin),
        fases: null,
        isFase: true,
        isTarefaDoLegalize: historico.isTarefaDoLegalize,
        possuiFasesPosterioresConcluidas: fase.possuiFasesPosterioresConcluidas,
        tipoDeTarefaId: historico.tipoDeTarefaId,
        atendimentoId: historico.atendimentoId,
        documentoId: fase.documentoId,
        descricao: fase.descricao
      }

      return fasesDto;
    },

    verificarTipoUsuarioETarefaDeFases(historico) {
      if(this.isSuperAdm) return true;
      if(this.isOperadorAdmin) return true;

      let isTarefaDeFases = historico.fases != null;
      if(!isTarefaDeFases) return true;

      const responsavelLogadoUWD = acessoUtils.adquirirUWDDoUsuarioLogado();
      let operadorLogadoIsReponsavelDaTarefa = historico?.responsavel?.id == responsavelLogadoUWD;
      if(operadorLogadoIsReponsavelDaTarefa) return true;
      
      const isLider = !!this.liderancas.find(d => d.id == historico.departamentoId);
      if(isLider) return true;

      let isFiltroSemResponsavel = this.responsavelId == "sem responsavel" || this.responsavelId == null;
      let isTarefaSemResponsavel = historico?.responsavel?.id == "sem responsavel" || historico?.responsavel?.id == null;
      return isFiltroSemResponsavel && isTarefaSemResponsavel;
    },

    _montarNomeDaEmpresaFormatado(empresa) {
      empresa.nomeFormatado = `${empresa.externoId} - ${empresa.nome}`;
      return empresa;
    },
 
    async listarResponsaveis() {
      this.modalLoading.campoResponsavel = true;
      this.responsavelOptions = await usuarioService.listarResponsaveis(true);
      this.modalLoading.campoResponsavel = false;
      return this.responsavelOptions;
    },
    selecionarResponsavel() {
      if (!!!this.responsavelOptions) return;
      const responsavelLogadoUWD = acessoUtils.adquirirUWDDoUsuarioLogado();
      const responsavelLogadoObject = this.responsavelOptions.find(
        (responsavel) => responsavel.value == responsavelLogadoUWD
      );
      this.responsavelId = !!responsavelLogadoObject ? responsavelLogadoUWD : "";
    },

    async listarDepartamentos() {
      this.modalLoading.campoDepartamento = true;
      var departamentos = await service.listarDepartamentos();
      this.listaDepartamentos = departamentos.map((departamento) => {
        return {
          value: departamento.value.toString(),
          label: departamento.label,
        };
      });

      var departamentosPadroes = await service.listarDepartamentosPadroes();
      departamentosPadroes.forEach((departamentoPadrao) => {
        this.listaDepartamentos.push(departamentoPadrao);
      });
      this.modalLoading.campoDepartamento = false;
      return this.listaDepartamentos;
    },

    async listarDepartamentosFase() {
      this.modalLoading.campoDepartamento = true;

      if (!this.isSuperAdm) {
        const departamentoService = await this.adquirirDepartamentoService();
        let departamentos = await departamentoService.listarTodosDepartamentos();
        this.listaTodosDepartamentos = departamentos.map((departamento) => {
          return {
            value: departamento?.value?.toString(),
            label: departamento?.label,
          };
        });
      } else {
        this.listaTodosDepartamentos = this.listaDepartamentos;
      }

      this.modalLoading.campoDepartamento = false;
      return this.listaTodosDepartamentos;
    },

    async listarEmpresas() {
      this.modalLoading.campoEmpresas = true;
      this.listaEmpresas = await empresasService.listarEmpresas();
      this.modalLoading.campoEmpresas = false;      
      return this.listaEmpresas;
    },

    async listarEmpresasSemDataDeSaida() {
      this.modalLoading.campoEmpresas = true;
      const filtros = {
        'filter[dataSaidaEscritorio]': empresasService.DATA_DE_SAIDA_PADRAO,
        'filter[legalizacaoEmAndamento]': false
      }
      this.listaEmpresasSemDataDeSaida = await empresasService.listarEmpresas(filtros);
      this.modalLoading.campoEmpresas = false;
      return this.listaEmpresasSemDataDeSaida;
    },

    adquirirIntervaloDeHoje() {
      let hoje = utils.formatarCampoDataParaEnvioAoBackendSemHora(new Date());

      return {
        dataInicial: hoje,
        dataFinal: hoje
      };
    },

    adquirirIntervaloSemana() {
      let hoje = new Date();
      const primeiroDia = hoje.getDate() - hoje.getDay();
      const ultimoDia = primeiroDia + 6;
      
      const primeiroDiaFormatado = new Date(hoje.setDate(primeiroDia)).toUTCString();
      hoje = new Date();
      const ultimoDiaFormatado = new Date(hoje.setDate(ultimoDia)).toUTCString();

      return {
        dataInicial: utils.formatarCampoDataParaEnvioAoBackendSemHora(primeiroDiaFormatado),
        dataFinal: utils.formatarCampoDataParaEnvioAoBackendSemHora(ultimoDiaFormatado)
      };
    },

    adquirirIntervaloMes() {
      const hoje = new Date();
      const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

      return {
        dataInicial: utils.formatarCampoDataParaEnvioAoBackendSemHora(primeiroDia),
        dataFinal: utils.formatarCampoDataParaEnvioAoBackendSemHora(ultimoDia)
      };
    },

    gerarIntervalos() {
      const hoje = this.adquirirIntervaloDeHoje();
      const semana = this.adquirirIntervaloSemana();
      const mes = this.adquirirIntervaloMes();
      
      this.intervalosOptions = [
        {
          id: "btn-filtro-intervalo-hoje",
          label: "Hoje",
          isSelected: true,
          value: hoje,
        },
        {
          id: "btn-filtro-intervalo-semana",
          label: "Esta semana",
          isSelected: false,
          value: semana,
        },
        {
          id: "btn-filtro-intervalo-mes",
          label: "Este mês",
          isSelected: false,
          value: mes,
        },
      ];
      return this.intervalosOptions;
    },

    gerarStatus() {
      const opcoesFiltroStatus = [
        {
          id: "checkbox-status-a-fazer",
          label: "A fazer",
          isSelecionada: true,
          valor: `1`,
        },
        {
          id: "checkbox-status-atrasada",
          label: "Atrasada",
          isSelecionada: true,
          valor: `5`,
        },
        {
          id: "checkbox-status-paralisada",
          label: "Paralisada",
          isSelecionada: false,
          valor: `8`,
        },
        {
          id: "checkbox-status-concluida",
          label: "Concluído",
          isSelecionada: false,
          valor: `2`,
        },
      ];
      if(configuracoesStore.GerarBaixaPorLeitura) {
        const optEnviado = {
          id: "checkbox-status-enviado",
          label: "Enviado",
          isSelecionada: false,
          valor: `7`,
        }
        opcoesFiltroStatus.push(optEnviado)
      }
      this.statusOptions = opcoesFiltroStatus;
    },

    gerarFiltroStatus(valores) {
      this.atualizarStatusOptions(valores);

      if (Array.isArray(valores)) {
        this.filtroStatus = `${valores}`;
      } else {
        this.filtroStatus = "";
      }
    },

    atualizarPagina(pagina) {
      this.pagina = pagina;
      this._carregarListagem();
    },
    atualizarLimite(limite) {
      this.limite = limite;
      this._carregarListagem();
    },
    atualizarStatusOptions(valores) {
      this.statusOptions.forEach((status) => {
        status.isSelecionada = valores.includes(status.valor);
      });
    },
    async iniciarModalDetalhesHistorico(historico) {
      this.isModalDetalhesHistoricoAtivo = true;
      this.tituloModalDetalhesHistorico = this.gerarTituloModalDetalhesHistorico(historico);
      this.detalhesHistorico = historico;
    },
    iniciarModalEdicaoDeFases(historico) {
      if(historico.status == "Paralisada" || historico.isAlgumaFaseParalisada){
        toastUtils.dangerToast(`Tarefas e/ou fases com status "Paralisada" não podem ser editadas.`);
        return
      }
      this.isModalEdicaoDeFasesActive = true;
      this.avulsaEmEdicao = historico;
    },
    doAbrirModalAlterarVencimento(item, event) {
      this.isAlterarDataActive = true;
      this.itemAlterarData = item;
    },
    doFecharModalAlterarVencimento(event) {
      this.isAlterarDataActive = event;
    },
    doRecarregarListagemAlteracaoVencimento(event) {
      if(!event) return;
      this._carregarListagem()
    },
    possuiFasesComStatus(historico, status) {
      let fases = historico.fases;
      let isTarefaDeFases = fases != null;
      
      if(!isTarefaDeFases) {
        return false;
      }

      for (let i = 0; i < fases?.length; i++) {
        if (fases[i].status.toLowerCase() === status.toLowerCase()) {
            return true;
        }
      }

      return false;
    },
    gerarDataCompetencia(data, historico) {
      return historico.textoPeriodoReferencia;
    },
    gerarTituloModalDetalhesHistorico(historico) {
      const nome = historico.nome || historico.nomeCompleto || '';
      let tituloBase = nome + " - ";
      const data = historico.data;
      tituloBase = tituloBase + this.gerarDataCompetencia(data, historico);
      return tituloBase;
    },
    isAvulsa(historico) {
      return !!!historico?.recorrencia?.id || !!!historico?.competencia?.id;
    },
    fecharModalDetalhesHistorico() {
      this.isModalDetalhesHistoricoAtivo = false;
      this.tituloModalDetalhesHistorico = "";
      this.detalhesHistorico = null;
    },
    fecharModalPermissoes() {
      this.isModalPermissoes = false;
      this.tituloModalPermissoes = "";
      this.departamentosSemPermissao = [];
      this.novoResponsavel = "";
      this.novoDepartamento = "";
      this.historicoTarefaIdParaTransferirResponsavel = null;
      this.faseIdParaTransferirResponsavel = null;
      this.isTemPermissaoParaDepartamentoEscolhido = true;
      this.isTemPermissaoParaEmpresaEscolhida = true;
      this.atualizarPagina(this.pagina);
    },
    pegaDepartamentosSemPermissao() {
      if (!this.isTemPermissaoParaDepartamentoEscolhido)  {
          for (const item of this.listaDepartamentos) {
            if (item.value == this.novoDepartamento) {
              this.departamentosSemPermissao.push(item);
            }
          }
      }
    },
    pegaEmpresasSemPermissao() {
      if (!this.isTemPermissaoParaEmpresaEscolhida) {
        this.empresasSemPermissao = this.objetoHistorico.empresa.nome
      }
    },
    HTMLToText(HTMLAsString, querySelectorTarget) {
      document.querySelector(querySelectorTarget).innerHTML= HTMLAsString;
    },
    exibirFiltrosAvancados() {
      this.activarFiltroAvancado = !this.activarFiltroAvancado;
      if(!this.activarFiltroAvancado) {
        this.$refs.filtroBotoesIntervalo._selecionarDefault();
      }
    },
    deveValidarNovoPrazoEntrega(novoPrazoEntrega) {
      const historicoFiltrado = this.historicos.find(historico => historico.id === this.historicoTarefaIdParaEditarVencimentoTarefaAvulsa);
      const prazoEntrefaAntigoAsDate = this.formatarData(historicoFiltrado.data);
      const novoPrazoEntregaAsDate = this.formatarData(novoPrazoEntrega);

      if(novoPrazoEntregaAsDate instanceof Date) {
       if (novoPrazoEntregaAsDate.toISOString() === prazoEntrefaAntigoAsDate.toISOString()) {
          this.mensagemDeErroEdicaoTarefaAvulsa = "O prazo de entrega informado é o mesmo prazo de entrega da tarefa, portanto não pode ser ajustado.";
        } else if (novoPrazoEntregaAsDate < prazoEntrefaAntigoAsDate) {
          this.mensagemDeErroEdicaoTarefaAvulsa = "O prazo de entrega informado é o menor que prazo de entrega da tarefa, portanto não pode ser ajustado.";
        }
      }

      return novoPrazoEntregaAsDate <= prazoEntrefaAntigoAsDate;
  },
  formatarData(dataParaFormatar) {      
      let dia, mes, ano;

      if(dataParaFormatar != null) {
        if(dataParaFormatar.includes("-")) {
          const dateParts = dataParaFormatar.split('-');
          dia = parseInt(dateParts[2]);
          mes = parseInt(dateParts[1]) - 1;
          ano = parseInt(dateParts[0]);
          return  new Date(ano, mes, dia);
        } else {
          const dateParts = dataParaFormatar.split('/');
          dia = parseInt(dateParts[0]);
          mes = parseInt(dateParts[1]) - 1;
          ano = parseInt(dateParts[2]);
          return new Date(ano, mes, dia);
        }
      }
    },
    deveBloquearSelectResponsavel() {
      return !!!this.operadorLogadoSuperAdmOuAdm;
    },
    async buscarOperadorLogado() {
        const operador = await acessoUtils.adquirirOperadorLogado();
        this.operadorLogadoSuperAdmOuAdm = acessoUtils.isOperadorAdmin(operador) || acessoUtils.isOperadorSuperAdm(operador);
    },
    async buscarLiderancas() {
      const service = await this.adquirirDepartamentoService();
      this.liderancas = await service.getLiderancas();
    },
    async montaObjetoDepartamentoPermissoes(responsavel) {
      if (responsavel.id != 1) {
        if (responsavel.acessaTodosDepartamentos) {
        this.isTemPermissaoParaDepartamentoEscolhido = true
        } else {
          this.isTemPermissaoParaDepartamentoEscolhido = responsavel.idsDepartamentos.includes(parseInt(this.novoDepartamento));
        }
      }
    },
    async montaObjetoEmpresaPermissoes(responsavel) {   
      if (responsavel.id != 1) {
        if (responsavel.acessaTodasEmpresas) {
        this.isTemPermissaoParaEmpresaEscolhida = true
        } else {
          const empresaId = this.objetoHistorico.empresa.id;

          this.isTemPermissaoParaEmpresaEscolhida = responsavel.idsEmpresas.includes(empresaId);
        }
      }
    },
    setaValorPadraoDepartamentoSeTiverNulo() {
      if (this.novoDepartamento === "") {
        if (this.objetoHistorico.departamento) {
          const departamentoDefault = this.listaDepartamentos.find(element => element.label === this.objetoHistorico.departamento);
          this.novoDepartamento = departamentoDefault.value
        }
      }
    },
    setaValorPadraoResponsavelSeTiverNulo() {
      if (this.novoResponsavel === "") {
        const responsavelDefault = this.responsavelOptions.find(element => element.label === this.objetoHistorico.responsavel);
        if (responsavelDefault) {
          this.novoResponsavel = responsavelDefault.value
        }
      }
    },
    getDepartamentosEEmpresasSemPermissao(value) {
      this.listaDepartamentosSemPermissao = value.departamentosSemPermissao;
      this.listaEmpresasSemPermissao = value.empresasSemPermissao;

      if (this.listaDepartamentosSemPermissao.length > 0 || this.listaEmpresasSemPermissao.length > 0) {
        this.isModalDashboardPermissaoActive=true;
      }
    },
    isPodeAbrirModal(value) {
      this.isAbreModal = value;
      this.isModalActive = false;
    },
    importarModelo() {
      this.abreModalCamposModelo = false;
      this.$refs.modalCadastroTarefas.importarModeloSelecionado();
    },
    evitarImportacaoModelo() {
      this.abreModalCamposModelo = false;
    },
    ativarModalCamposModelo(value) {
      this.abreModalCamposModelo = value;
    },
    async adquirirModeloService() {
      const { modeloService } = await import('../../service/modelo-service.js');
      return modeloService;
    },
    async carregarListaDeModelos() {
      const modeloService = await this.adquirirModeloService();

      const listaDeModelos = await modeloService.listarTodos({
        'sort[ASC]': 'nome',
        limit: 100
      });

      this.listaDeModelos = listaDeModelos;
      this.listaDeModelosExibicao = listaDeModelos.map((element) => {
        return {
          value: element.id,
          label: element.nome
        };
      })
    },
    async exportarPlanilha() {
      this.isBtnExportarPlanilhaLoading = true;
      
       try {
        await service.exportarPlanilha(this.filtrosRequisicaoHistorico);
        toastUtils.successToast('Download realizado com sucesso!');
      } catch (e) {
        toastUtils.dangerToast('Ocorreu um erro ao exportar a planilha.');
      } finally {
        this.isBtnExportarPlanilhaLoading = false;
      }
    },

  },
  watch: {
    filtroDataEntregaInicial(valorNovo) {
      if(!!!valorNovo && !!!this.filtroDataEntregaFinal && this.$refs.filtroBotoesIntervalo.valor == null) {
        this.$refs.filtroBotoesIntervalo._selecionarDefault();
      } else if(!!valorNovo) {
        this.$refs.filtroBotoesIntervalo.valor = null;
      }
    },
    filtroDataEntregaFinal(valorNovo) {
      if(!!!valorNovo && !!!this.filtroDataEntregaInicial && this.$refs.filtroBotoesIntervalo.valor == null) {
        this.$refs.filtroBotoesIntervalo._selecionarDefault();
      } else if(!!valorNovo) {
        this.$refs.filtroBotoesIntervalo.valor = null;
      }
    },
    filtroDataConclusaoInicial(valorNovo) {
      if(!!!valorNovo && !!!this.filtroDataConclusaoFinal && this.$refs.filtroBotoesIntervalo.valor == null) {
        this.$refs.filtroBotoesIntervalo._selecionarDefault();
      } else if(!!valorNovo) {
        this.$refs.filtroBotoesIntervalo.valor = null;
      }
    },
    filtroDataConclusaoFinal(valorNovo) {
      if(!!!valorNovo && !!!this.filtroDataConclusaoInicial && this.$refs.filtroBotoesIntervalo.valor == null) {
        this.$refs.filtroBotoesIntervalo._selecionarDefault();
      } else if(!!valorNovo) {
        this.$refs.filtroBotoesIntervalo.valor = null;
      }
    }
  },
  async created() {
    this.buscarOperadorLogado();
    this.buscarLiderancas();
    this.gerarIntervalos();
    this.gerarStatus();
    await this.listarResponsaveis();
    this.selecionarResponsavel();
    this.listarEmpresas();
    await this.listarDepartamentos();
    await this.listarDepartamentosFase();
    this._carregarListagem();
    this.carregarListaDeModelos();
  },
};
</script>
<style lang="scss" scoped>
.multiselect-econtador {
  margin: 0;
}
.columns.is-0 > .column {
  padding-left: 0;
  padding-right: 0;
}
.columns.is-1 {
  margin-left:-0.25em;
  margin-right:-0.25em;
 & > .column {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  } 
}
.columns.is-2 > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.columns.is-3 > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.columns.is-4 > .column {
  padding-left: 1rem;
  padding-right: 1rem;
}
.columns.is-5 > .column {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.columns.is-6 > .column {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.columns.is-7 > .column {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.columns.is-8 > .column {
  padding-left: 2rem;
  padding-right: 2rem;
}
.column.pl-7 {
  padding-left: 4.5rem !important;
}
.column.pl-8 {
  padding-left: 6rem !important;
}

.box-filtro-avancado {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
}

.btn-container {
  @media screen and (max-width: 600px) {
    margin-right: 0;
  }

  @media screen and (min-width: 900px) {
    margin-right: auto;
  }
}

.tipLabel {
  color: #000000;
  font-size: 12px;
}

</style>
<style lang="scss">
  .tabela-fase-branca table tr {
    background:#FFF!important;
    &:hover {
      background: hsl(0deg, 0%, 96%)!important;
    }
  }
  table {
    .is-toggle-action {
      position:relative;
      input[type=checkbox] {
        opacity:0;
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        pointer-events: none;
      }
    }
    & > tr, & > tbody > tr, & > thead > tr {
      & + .is-togglable-row {
        tr, th, td, th  > *, td > * {
          max-height:0;
          overflow:hidden;
          padding-top:0;
          padding-bottom:0;
          margin-top:0;
          margin-bottom:0;
          transition: overflow 0s ease-out 0.35s, 0.35s ease-out 0s;
        }
      }
      &.is-toggled + .is-togglable-row {
        tr, th, td, th  > *, td > * {
          max-height:1000vh;
          overflow:visible;
          transition: overflow 0s ease-in 0.35s, 0.35s ease-in 0s;
        }
      }
    }
  }
</style>